import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FmlxSwitch, FmlxTooltip} from 'fmlx-common-ui';
import {checkLoadCellError} from 'stores/business/loadCellErrorBusiness';
import {
  openSetupWizardPage,
  openTipsPickupCalibrationMenu,
  openTrayCalibrationPage,
} from 'stores/business/menuBusiness';

import {showModalType} from 'stores/actions/typedModalAction';
import {getInstrumentProcessStatus} from 'api/instrumentManagementApi';
import {InstrumentProcessType} from 'constants/instrumentStatusEnum';
import {setErrorCodeNumber} from 'stores/business/commonBusiness';
import {setInstrumentProcess} from 'stores/business/instrumentStatusBusiness';
import {checkAndUpdateIdleHumidityStatus} from 'stores/business/humidifierBusiness';
import {selectIsHumidifierConnected, selectIsHumidifierInstalled} from 'stores/selectors/humidifierSelectors';
import {selectIsInstrumentOperational, selectIsLabwareOperational} from 'stores/selectors/instrumentSelectors';
import {
  ViewMode,
  CurrentStateEnum,
  Feedback,
  LicenseStatus,
  FastRobotErrorcode,
  ModalType,
} from '../../constants/dataEnum';
import {UserRoleIcons, SideMenuRight} from '../../constants/userManagementEnum';

import {
  setDrawerVisibility,
  setHeadChannelsConfigOpen,
  changeView,
  showLoading,
  hideLoading,
  showSnackbar,
} from '../../stores/actions/appStateAction';
import {checkIsTouchProbeExtendedWithModal} from '../../stores/business/modalStateBusinessAction';

import {recoverRunningProtocol} from '../../stores/business/runtimeBusiness';
import {logout} from '../../stores/business/sessionBusiness';
import {
  getRunningProtocol,
  goToProtocolEditor,
  onExistProtocolRunning,
} from '../../stores/business/protocolManagementBusiness';
import {
  getFastInfo,
  getInstrumentStatus,
  moveToIdlePosition,
  visionCompatibilityCheck,
} from '../../stores/business/instrumentBusiness';
import {getLicenseData} from '../../stores/business/licenseBusiness';
import {disableAutosave, enableAutosave} from '../../stores/business/protocolEditorBusiness';
import {isUserOperator, setExplorerViewSettings} from '../../stores/business/userManagementBusiness';
import {
  showConfirmationModal,
  showIsBusyModal,
  showModalConnectionFailed,
} from '../../stores/business/commonModalBusiness';
import {fastRecovery} from '../../stores/business/recoveryBusiness';

import withIntl from '../../lib/withIntl';

import SideMenu from './SideMenu';
import ModalChangePassword from '../UserManagement/ModalChangePassword';
// eslint-disable-next-line import/namespace, import/default, import/no-named-as-default, import/no-named-as-default-member
import ModalAddEditUser from '../UserManagement/ModalAddEditUser';
import HeadChannelsConfig from '../HeadChannelsConfig/HeadChannelsConfig';
import {fastCommonActuatorAPIErrorHandler} from '../../stores/business/errorHandlerBusiness';
import {saveState} from '../../stores/business/stateBusiness';
import {resetSelectedProtocolOrFolder} from '../../stores/actions/protocolExplorerAction';

function mapStateToProps(state) {
  return {
    appState: state.appState,
    sessionState: state.sessionState,
    userManagementState: state.userManagementState,
    licenseStatus: state.licenseState.status,
    protocolEditorAutosaveState: state.protocolEditorState.autosave,
    defaultViewSettings: state.protocolExplorerState.defaultViewSettings,
    fastInstrumentType: state.aboutState?.fastInstrumentType,
    isHumidifierInstalled: selectIsHumidifierInstalled(state),
    isHumidifierConnected: selectIsHumidifierConnected(state),
    isInstrumentOperational: selectIsInstrumentOperational(state),
    isLabwareOperational: selectIsLabwareOperational(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetDrawerVisibility: bindActionCreators(setDrawerVisibility, dispatch),
    onSetHeadChannelsConfigOpen: bindActionCreators(setHeadChannelsConfigOpen, dispatch),
    onChangeView: bindActionCreators(changeView, dispatch),
    onResetSelectedProtocolOrFolder: bindActionCreators(resetSelectedProtocolOrFolder, dispatch),
    onFastGetInstalledTrayAndOpenTrayCalibrationPage: bindActionCreators(openTrayCalibrationPage, dispatch),
    onShowModalConnectionFailed: bindActionCreators(showModalConnectionFailed, dispatch),
    onShowIsBusyModal: bindActionCreators(showIsBusyModal, dispatch),
    onShowLoading: bindActionCreators(showLoading, dispatch),
    onHideLoading: bindActionCreators(hideLoading, dispatch),
    onShowSnackbar: bindActionCreators(showSnackbar, dispatch),
    onLogout: bindActionCreators(logout, dispatch),
    onRecoverRunningProtocol: bindActionCreators(recoverRunningProtocol, dispatch),
    onGetInstrumentStatus: bindActionCreators(getInstrumentStatus, dispatch),
    onGetRunningProtocol: bindActionCreators(getRunningProtocol, dispatch),
    onRecoveryAction: bindActionCreators(fastRecovery, dispatch),
    onMoveToIdlePosition: bindActionCreators(moveToIdlePosition, dispatch),
    onGetFastInfo: bindActionCreators(getFastInfo, dispatch),
    protocolManagementBusinessGoToProtocolEditor: bindActionCreators(goToProtocolEditor, dispatch),
    licenseBussinessGetLicenseData: bindActionCreators(getLicenseData, dispatch),
    protocolManagementBusinessOnExistProtocolRunning: bindActionCreators(onExistProtocolRunning, dispatch),
    modalStateBusinessActionShowTouchProbeExtendedModal: bindActionCreators(
      checkIsTouchProbeExtendedWithModal,
      dispatch,
    ),
    userManagementBusinessIsOperator: bindActionCreators(isUserOperator, dispatch),
    protocolEditorActionSetAutosaveEnableAutosave: bindActionCreators(enableAutosave, dispatch),
    protocolEditorActionDisableAutosave: bindActionCreators(disableAutosave, dispatch),
    commonModalBusinessShowConfirmationModal: bindActionCreators(showConfirmationModal, dispatch),
    menuBusinessOpenSetupWizardPage: bindActionCreators(openSetupWizardPage, dispatch),
    errorHandlerBusinessfastCommonActuatorAPIErrorHandler: bindActionCreators(
      fastCommonActuatorAPIErrorHandler,
      dispatch,
    ),
    instrumentBusinessVisionCompatibilityCheck: bindActionCreators(visionCompatibilityCheck, dispatch),
    saveStateAction: bindActionCreators(saveState, dispatch),
    userManagementBusinessSetExplorerViewSettings: bindActionCreators(setExplorerViewSettings, dispatch),
    sideMenuBusinessOpenTipsPickupCalibrationMenu: bindActionCreators(openTipsPickupCalibrationMenu, dispatch),
    onCheckLoadCellError: bindActionCreators(checkLoadCellError, dispatch),
    showModalType: bindActionCreators(showModalType, dispatch),
    setErrorCodeNumber: bindActionCreators(setErrorCodeNumber, dispatch),
    setInstrumentProcess: bindActionCreators(setInstrumentProcess, dispatch),
    checkAndUpdateIdleHumidityStatus: bindActionCreators(checkAndUpdateIdleHumidityStatus, dispatch),
  };
}

class SideMenuContainer extends React.Component {
  constructor(props) {
    super(props);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.trayInputRef = React.createRef();

    this.state = {
      editAccountModalVisible: false,
      changePasswordModalVisible: false,
      disableAutosaveMenu: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {changePasswordModalVisible, editAccountModalVisible, disableAutosaveMenu} = this.state;

    const {appState} = this.props;
    if (
      nextProps.appState.viewMode === ViewMode.LOGIN &&
      (nextState.changePasswordModalVisible || nextState.editAccountModalVisible)
    ) {
      return true;
    }
    if (
      nextProps !== this.props ||
      nextState.changePasswordModalVisible !== changePasswordModalVisible ||
      nextState.editAccountModalVisible !== editAccountModalVisible ||
      (nextState.disableAutosave !== disableAutosaveMenu && appState.showDrawer)
    ) {
      return true;
    }
    return false;
  }

  componentDidUpdate() {
    const {appState} = this.props;
    const {showDrawer} = appState;
    const {changePasswordModalVisible, editAccountModalVisible} = this.state;

    if (showDrawer) this.isAutosaveDisabled();
    if (appState.viewMode === ViewMode.LOGIN && (changePasswordModalVisible || editAccountModalVisible)) {
      if (changePasswordModalVisible) {
        this.changePasswordModalOnClose();
      }
      if (editAccountModalVisible) {
        this.editAccountModalOnClose();
      }
    }
  }

  hideDrawer = async () => {
    const {onSetDrawerVisibility, saveStateAction} = this.props;

    await onSetDrawerVisibility(false);
    saveStateAction(false);
  };

  onDrawerBlurAction = () => {
    this.hideDrawer();
  };

  buttonExplorerHandleClick = () => {
    console.info('click side menu - explorer');
    const {appState, onChangeView, onResetSelectedProtocolOrFolder} = this.props;
    const {viewMode} = appState;

    if (viewMode !== ViewMode.EXPLORER) {
      onChangeView(ViewMode.EXPLORER);
      onResetSelectedProtocolOrFolder();
      // showLoading('Loading Protocols...'); // FIX ME loading is not working properly
    }

    this.hideDrawer();
    // save state after get response in app.js on getProtocols
  };

  buttonAutosaveHandleClick = async () => {
    console.info('click side menu - autosave');

    const {
      protocolEditorAutosaveState,
      protocolEditorActionSetAutosaveEnableAutosave,
      protocolEditorActionDisableAutosave,
      commonModalBusinessShowConfirmationModal,
      onShowSnackbar,
      intl,
    } = this.props;

    if (protocolEditorAutosaveState) {
      commonModalBusinessShowConfirmationModal('modal.autoSaveConfirmation', () => {
        protocolEditorActionDisableAutosave();
        onShowSnackbar(Feedback.WARNING, intl.formatMessage({id: 'explorer.autosave.snackbar.autosaveDisabled'}));
      });
    } else {
      await protocolEditorActionSetAutosaveEnableAutosave();
      onShowSnackbar(Feedback.SUCCESS, intl.formatMessage({id: 'explorer.autosave.snackbar.autosaveEnabled'}));
    }
  };

  isAutosaveDisabled = async () => {
    const {onGetRunningProtocol, onGetInstrumentStatus, sessionState, isInstrumentOperational} = this.props;
    const {disableAutosaveMenu} = this.state;

    let isDisabled = false;

    const runningProtocol = await onGetRunningProtocol();

    if (!isInstrumentOperational) {
      isDisabled = true;
    } else if (runningProtocol?.payload) {
      const {userId: runningProtocolUserId} = runningProtocol.payload.user;
      // eslint-disable-next-line no-unsafe-optional-chaining
      const {userId} = sessionState?.user;
      const isExecutor = runningProtocolUserId === userId;
      const instrumentStatus = await onGetInstrumentStatus();

      if (isExecutor && instrumentStatus?.currentState !== CurrentStateEnum.IDLE) {
        isDisabled = true;
      }
    }

    if (disableAutosaveMenu !== isDisabled) this.setState({disableAutosaveMenu: isDisabled});
  };

  buttonTrayCalibrationHandleClick = async () => {
    console.info('click side menu - tray calibration');

    const {onFastGetInstalledTrayAndOpenTrayCalibrationPage, onCheckLoadCellError} = this.props;

    const isLoadCellError = await onCheckLoadCellError(null, this.buttonTrayCalibrationHandleClick);
    this.hideDrawer();
    if (isLoadCellError) return;

    await onFastGetInstalledTrayAndOpenTrayCalibrationPage();
  };

  buttonHeadChannelsConfigClick = async () => {
    const {
      onSetHeadChannelsConfigOpen,
      onShowModalConnectionFailed,
      onShowIsBusyModal,
      onShowLoading,
      onHideLoading,
      onGetInstrumentStatus,
      onGetRunningProtocol,
      intl,
    } = this.props;
    onShowLoading(intl.formatMessage({id: 'instrument.loading.checkConnection'}));
    const response = await onGetInstrumentStatus();
    onHideLoading();

    if (!response) {
      onShowModalConnectionFailed();
    } else if (response?.currentState === CurrentStateEnum.IDLE) {
      // only open when on idle state
      onSetHeadChannelsConfigOpen(true);
    } else {
      const runningProtocolResponse = await onGetRunningProtocol();
      // eslint-disable-next-line no-unsafe-optional-chaining
      const {username} = runningProtocolResponse?.payload?.user;
      onShowIsBusyModal(username);
    }
    this.hideDrawer();
  };

  labwareManagerClick = () => {
    const {appState, onChangeView} = this.props;
    const {viewMode} = appState;

    if (viewMode !== ViewMode.LABWARE_MANAGER) {
      onChangeView(ViewMode.LABWARE_MANAGER);
    }

    this.hideDrawer();
  };

  buttonSetupWizardClick = async () => {
    const {
      onShowModalConnectionFailed,
      onShowLoading,
      onHideLoading,
      menuBusinessOpenSetupWizardPage,
      instrumentBusinessVisionCompatibilityCheck,
      errorHandlerBusinessfastCommonActuatorAPIErrorHandler,
      onCheckLoadCellError,
      intl,
    } = this.props;

    const isLoadCellError = await onCheckLoadCellError(null, this.buttonSetupWizardClick);
    if (isLoadCellError) {
      this.hideDrawer();
      return;
    }

    onShowLoading(intl.formatMessage({id: 'instrument.loading.checkConnection'}));
    const visionCompatibilityRes = await instrumentBusinessVisionCompatibilityCheck();
    onHideLoading();

    if (!visionCompatibilityRes) {
      onShowModalConnectionFailed();
    } else if (visionCompatibilityRes !== FastRobotErrorcode.NoError) {
      errorHandlerBusinessfastCommonActuatorAPIErrorHandler(visionCompatibilityRes);
    } else {
      menuBusinessOpenSetupWizardPage();
    }

    this.hideDrawer();
  };

  dispenseReportExplorerClick = () => {
    const {appState, onChangeView} = this.props;
    const {viewMode} = appState;

    if (viewMode !== ViewMode.DISPENSE_REPORT_EXPLORER) {
      onChangeView(ViewMode.DISPENSE_REPORT_EXPLORER);
    }

    this.hideDrawer();
  };

  moveToEditor = async () => {
    console.info('click side menu - protocol editor');
    const {
      protocolManagementBusinessGoToProtocolEditor,
      protocolManagementBusinessOnExistProtocolRunning,
      onRecoverRunningProtocol,
      onShowLoading,
      onHideLoading,
      userManagementBusinessIsOperator,
    } = this.props;
    const isOperator = userManagementBusinessIsOperator();

    onShowLoading();

    const isSameWithRunningProtocol = await protocolManagementBusinessOnExistProtocolRunning();
    this.hideDrawer();

    if (isSameWithRunningProtocol && isOperator) {
      await onRecoverRunningProtocol();
      onHideLoading();
      return;
    }

    if (!isSameWithRunningProtocol) await protocolManagementBusinessGoToProtocolEditor();
    onHideLoading();
  };

  editAccountButtonClick = () => {
    console.info('click side menu - account');

    this.hideDrawer();

    this.setState({editAccountModalVisible: true});
  };

  editAccountModalOnClose = (success) => {
    const {onLogout} = this.props;

    this.setState({editAccountModalVisible: false});

    if (success) {
      return;
    }

    // FIX ME does not have privilage
    onLogout();
  };

  userManagementButtonClick = () => {
    console.info('click side menu - user management');

    const {onChangeView} = this.props;

    onChangeView(ViewMode.USER_MANAGEMENT);
    this.hideDrawer();
  };

  changePasswordButtonClick = () => {
    console.info('click side menu - change password');

    this.hideDrawer();

    this.setState({changePasswordModalVisible: true});
  };

  changePasswordModalOnClose = () => {
    this.setState({changePasswordModalVisible: false});
  };

  logoutButtonClick = () => {
    console.info('click side menu - logout');

    const {onLogout, defaultViewSettings, userManagementBusinessSetExplorerViewSettings} = this.props;
    const {explorerViewMode, isProtocolSortedByDescending} = defaultViewSettings;

    // send the explorer default setting changes into back end
    if (explorerViewMode !== undefined && isProtocolSortedByDescending !== undefined) {
      userManagementBusinessSetExplorerViewSettings(explorerViewMode, isProtocolSortedByDescending);
    }

    this.hideDrawer();
    onLogout();
  };

  // eslint-disable-next-line class-methods-use-this
  openWebHelp = () => {
    window.open('http://help.formulatrix.com/fast');
  };

  buttonRuntimeHandleClick = async () => {
    console.info('click side menu - run time status');

    const {intl, onRecoverRunningProtocol, onShowLoading, onHideLoading} = this.props;

    this.hideDrawer();

    onShowLoading(intl.formatMessage({id: 'sideMenuContainer.loading.recoverRuntime'}));
    await onRecoverRunningProtocol();
    onHideLoading();
  };

  buttonRecoveryActionClick = async () => {
    console.info('click side menu - recovery action');

    const {
      onRecoveryAction,
      onMoveToIdlePosition,
      onShowModalConnectionFailed,
      onShowIsBusyModal,
      onShowLoading,
      onHideLoading,
      onGetInstrumentStatus,
      onGetRunningProtocol,
      onShowSnackbar,
      intl,
      modalStateBusinessActionShowTouchProbeExtendedModal,
      errorHandlerBusinessfastCommonActuatorAPIErrorHandler,
    } = this.props;

    this.hideDrawer();

    onShowLoading(intl.formatMessage({id: 'recoveryAction.loading'}));

    try {
      const response = await onGetInstrumentStatus();

      if (!response) {
        onHideLoading();
        onShowModalConnectionFailed();
      } else if (response?.currentState === CurrentStateEnum.IDLE) {
        // only execute when on idle state
        try {
          await onRecoveryAction(async () => {
            const moveToIdleRes = await onMoveToIdlePosition();
            if (moveToIdleRes !== FastRobotErrorcode.NoError) {
              errorHandlerBusinessfastCommonActuatorAPIErrorHandler(moveToIdleRes);
            } else {
              modalStateBusinessActionShowTouchProbeExtendedModal(() => {
                onShowSnackbar(Feedback.SUCCESS, intl.formatMessage({id: 'recoveryAction.success'}));
              });
            }
          });
        } catch (error) {
          onHideLoading();
          console.log('buttonRecoveryActionClick error', error);
        }
      } else {
        // show devices busy modal
        const runningProtocolResponse = await onGetRunningProtocol();
        // eslint-disable-next-line no-unsafe-optional-chaining
        const {username} = runningProtocolResponse?.payload?.user;
        onHideLoading();
        onShowIsBusyModal(username);
      }
    } catch (err) {
      onHideLoading();
      onShowModalConnectionFailed();
    }
  };

  buttonAboutClick = async () => {
    console.info('click side menu - about');

    const {
      onChangeView,
      onGetFastInfo,
      licenseBussinessGetLicenseData,
      onShowLoading,
      onHideLoading,
      saveStateAction,
      intl,
    } = this.props;
    onShowLoading(intl.formatMessage({id: 'protocolEditor.generalLoading.message'}));
    // get software info
    await onGetFastInfo();
    saveStateAction(false);
    // get license data
    await licenseBussinessGetLicenseData();

    onHideLoading();

    onChangeView(ViewMode.ABOUT);

    this.hideDrawer();
  };

  getRoleRightsBasedOnRole = () => {
    const {sessionState, userManagementState} = this.props;
    const {userRole} = sessionState.user;
    const {availableRoleRights} = userManagementState;
    const roleRights = [];

    for (let i = 0, ii = availableRoleRights.length; i < ii; i += 1) {
      const rr = availableRoleRights[i];

      if (rr.roleId === userRole) {
        roleRights.push(rr);
      }
    }

    return roleRights;
  };

  getUserIcon = () => {
    const {sessionState, userManagementState} = this.props;
    const getRoleUser = userManagementState?.availableRoles.find(
      (avRole) => avRole.id === sessionState?.user?.userRole,
    );

    const defaultIconKey = 'Regular User';
    const defaultIconName = 'icon-Regular-User';
    const icon = UserRoleIcons.find((e) => e.key === (getRoleUser ? getRoleUser.name : defaultIconKey));

    return icon ? icon.name : defaultIconName;
  };

  hideMenu = (MENU) => {
    const getRoleUser = _.find(this.getRoleRightsBasedOnRole(), {componentName: MENU});

    if (getRoleUser) return false;

    return true;
  };

  downloadLogHandler = async () => {
    const {appState, onChangeView} = this.props;
    const {viewMode} = appState;

    this.hideDrawer();

    if (viewMode === ViewMode.LOG_LIST) {
      return;
    }

    onChangeView(ViewMode.LOG_LIST);
  };

  noLicense = () => {
    const {licenseStatus} = this.props;

    return (
      licenseStatus === LicenseStatus.NO_LICENSE ||
      licenseStatus === LicenseStatus.TRIAL_EXPIRED ||
      licenseStatus === LicenseStatus.TEMPORARY_EXPIRED
    );
  };

  getProtocolEditorTitle = () => {
    const {userManagementBusinessIsOperator} = this.props;
    const isOperator = userManagementBusinessIsOperator();
    if (isOperator) {
      return 'sideMenuContainer.protocolViewerMenu';
    }

    return 'sideMenuContainer.protocolEditorMenu';
  };

  hideDrawerAndOpenMenu = (menuFunc) => {
    menuFunc();
    this.hideDrawer();
  };

  backupAndRestoreDataHandler = async () => {
    const {showModalType, onShowIsBusyModal, setErrorCodeNumber, setInstrumentProcess, sessionState} = this.props;
    const {status, username: usernameExecutor = ''} = (await getInstrumentProcessStatus()) || {};

    if (status !== InstrumentProcessType.IDLE && usernameExecutor !== sessionState.user.username) {
      await setErrorCodeNumber(FastRobotErrorcode.Busy);
      onShowIsBusyModal(usernameExecutor);

      return;
    }

    setInstrumentProcess(InstrumentProcessType.BACKUP_AND_RESTORE_DATA);
    showModalType(ModalType.BACKUP_AND_RESTORE_DATA);
  };

  handleHumidityChange = async () => {
    const {checkAndUpdateIdleHumidityStatus, isHumidifierConnected, showModalType} = this.props;

    if (!isHumidifierConnected) {
      showModalType(ModalType.HUMIDIFIER_DISCONNECTED);
      return;
    }

    await checkAndUpdateIdleHumidityStatus();
    showModalType(ModalType.IDLE_HUMIDITY);
  };

  handlePlateRecognition = async () => {
    const {showModalType} = this.props;
    showModalType(ModalType.PLATE_RECOGNITION);
  };

  render() {
    const {
      appState,
      sessionState,
      userManagementState,
      intl,
      onSetHeadChannelsConfigOpen,
      protocolEditorAutosaveState,
      sideMenuBusinessOpenTipsPickupCalibrationMenu,
      isHumidifierInstalled,
      isInstrumentOperational,
      isLabwareOperational,
    } = this.props;
    const {showDrawer, headChannelsConfigOpen} = appState;
    const {editAccountModalVisible, changePasswordModalVisible} = this.state;
    const {disableAutosaveMenu} = this.state;
    // const isOperator = userManagementBusinessIsOperator();

    return (
      <div className="bootstrap-iso">
        <SideMenu
          showDrawer={showDrawer}
          onDrawerBlur={this.onDrawerBlurAction}
          title={intl.formatMessage({id: 'sideMenuContainer.title'})}
          closeLabel={intl.formatMessage({id: 'sideMenuContainer.closeLabel'})}
          menuList={[
            {
              title: sessionState.user.name || intl.formatMessage({id: 'sideMenuContainer.userMenu.defaultName'}),
              glyph: this.getUserIcon(),
              subMenuList: [
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.userMenu.subMenuList.account',
                  }),
                  onClick: this.editAccountButtonClick,
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.userMenu.subMenuList.userManagement',
                  }),
                  selected: appState.viewMode === ViewMode.USER_MANAGEMENT,
                  hidden: this.hideMenu(SideMenuRight.USER_MANAGEMENT),
                  onClick: this.userManagementButtonClick,
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.userMenu.subMenuList.changePassword',
                  }),
                  hidden: this.hideMenu(SideMenuRight.CHANGE_PASSWORD),
                  onClick: this.changePasswordButtonClick,
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.userMenu.subMenuList.logout',
                  }),
                  onClick: this.logoutButtonClick,
                },
              ],
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.explorerMenu',
              }),
              onClick: this.buttonExplorerHandleClick,
              hidden: this.hideMenu(SideMenuRight.EXPLORER),
              selected: appState.viewMode === ViewMode.EXPLORER,
              icon: 'explorer-icon',
            },
            {
              title: (
                <div>
                  <span>
                    {intl.formatMessage({
                      id: 'sideMenuContainer.autoSaveProtocol',
                    })}
                  </span>
                  <FmlxTooltip
                    title={intl.formatMessage(
                      {
                        id: isInstrumentOperational
                          ? 'sideMenuContainer.autoSaveProtocol.text.tooltip'
                          : 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument',
                      },
                      {
                        autoSaveStatus: protocolEditorAutosaveState
                          ? intl.formatMessage({id: 'sideMenuContainer.autoSaveProtocol.disabled.tooltip'})
                          : intl.formatMessage({id: 'sideMenuContainer.autoSaveProtocol.enabled.tooltip'}),
                      },
                    )}
                    placement="right"
                  >
                    <span style={{float: 'right', marginTop: '-3px'}}>
                      <FmlxSwitch
                        checked={protocolEditorAutosaveState}
                        size="sm"
                        onChange={() => false}
                        disabled={disableAutosaveMenu}
                      />
                    </span>
                  </FmlxTooltip>
                </div>
              ),
              onClick: this.buttonAutosaveHandleClick,
              hidden: this.hideMenu(SideMenuRight.AUTO_SAVE_PROTOCOL),
              icon: 'save-icon',
              disabled: disableAutosaveMenu,
              hideNoLicenseTooltip: true,
            },
            {
              title: intl.formatMessage({
                id: `${this.getProtocolEditorTitle()}`,
              }),
              onClick: this.moveToEditor,
              selected: appState.viewMode === ViewMode.PROTOCOL_EDITOR,
              icon: 'protocol-editor-icon',
              disabled: !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.runTimeStatusMenu',
              }),
              onClick: this.buttonRuntimeHandleClick,
              hidden: this.hideMenu(SideMenuRight.RUNTIME),
              selected: appState.viewMode === ViewMode.RUNTIME,
              icon: 'runtime-icon',
              disabled: !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.dispenseReportExplorer',
              }),
              onClick: this.dispenseReportExplorerClick,
              hidden: this.hideMenu(SideMenuRight.DISPENSE_REPORT_EXPLORER),
              selected: appState.viewMode === ViewMode.DISPENSE_REPORT_EXPLORER,
              icon: 'protocol-execution-report-icon',
              disabled: this.noLicense(),
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
            },
            {
              title: '',
              onClick: () => {},
              selected: null,
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.recoveryActionMenu',
              }),
              onClick: this.buttonRecoveryActionClick,
              icon: 'recovery-icon',
              disabled: this.noLicense() || !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.hardawareSettings',
              }),
              hidden: this.hideMenu(SideMenuRight.HARDWARE_SETTINGS),
              icon: 'tray-calibration-icon',
              disabled: !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
              subMenuList: [
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.trayCalibrationMenu',
                  }),
                  hidden: this.hideMenu(SideMenuRight.AUTO_TRAY_CALIBRATION),
                  onClick: this.buttonTrayCalibrationHandleClick,
                  disabled: this.noLicense(),
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.tipsPickupCalibration',
                  }),
                  hidden: this.hideMenu(SideMenuRight.TIPS_PICKUP_CALIBRATION),
                  onClick: () => this.hideDrawerAndOpenMenu(sideMenuBusinessOpenTipsPickupCalibrationMenu),
                  disabled: this.noLicense(),
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.headChannelsConfig',
                  }),
                  hidden: this.hideMenu(SideMenuRight.HEAD_CHANNELS_CONFIG),
                  onClick: this.buttonHeadChannelsConfigClick,
                  disabled: this.noLicense(),
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.idleHumidity',
                  }),
                  onClick: () => this.handleHumidityChange(),
                  hidden: !isHumidifierInstalled || this.hideMenu(SideMenuRight.IDLE_HUMIDITY),
                  disabled: this.noLicense(),
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.plateRecognition',
                  }),
                  hidden: this.hideMenu(SideMenuRight.PLATE_RECOGNITION),
                  onClick: () => this.handlePlateRecognition(),
                  disabled: this.noLicense(),
                },
              ],
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.labwareManager',
              }),
              onClick: this.labwareManagerClick,
              hidden: this.hideMenu(SideMenuRight.LABWARE_MANAGER),
              selected: appState.viewMode === ViewMode.LABWARE_MANAGER,
              icon: 'plate-type-editor',
              disabled: this.noLicense() || !isLabwareOperational,
              tootlipMessage:
                !isLabwareOperational || !isInstrumentOperational
                  ? `sideMenuContainer.disabledMenu.cannotUseThisFeature.${!isInstrumentOperational ? 'instrument' : 'labware'}`
                  : '',
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.setupWizard',
              }),
              onClick: this.buttonSetupWizardClick,
              selected: appState.viewMode === ViewMode.SETUP_WIZARD,
              icon: 'preparation-wizard-icon',
              disabled: this.noLicense() || !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
              hidden: this.hideMenu(SideMenuRight.SETUP_WIZARD),
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.helpMenu',
              }),
              icon: 'help-icon',
              subMenuList: [
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.faq',
                  }),
                  onClick: this.openWebHelp,
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.downloadLog',
                  }),
                  hidden: this.hideMenu(SideMenuRight.DOWNLOAD_LOG),
                  onClick: this.downloadLogHandler,
                },
                {
                  title: intl.formatMessage({
                    id: 'sideMenuContainer.backupAndRestoreData',
                  }),
                  onClick: this.backupAndRestoreDataHandler,
                  hidden: this.hideMenu(SideMenuRight.BACKUP_AND_RESTORE),
                  disabled: !isInstrumentOperational || this.noLicense(),
                  tootlipMessage: !isInstrumentOperational
                    ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                    : '',
                },
              ],
            },
            {
              title: intl.formatMessage({
                id: 'sideMenuContainer.about',
              }),
              onClick: this.buttonAboutClick,
              selected: appState.viewMode === ViewMode.PLATE_TYPE_EDITOR,
              icon: 'about-icon',
              disabled: !isInstrumentOperational,
              tootlipMessage: !isInstrumentOperational
                ? 'sideMenuContainer.disabledMenu.cannotUseThisFeature.instrument'
                : '',
            },
          ]}
        />
        {editAccountModalVisible && (
          <ModalAddEditUser
            showModal={editAccountModalVisible}
            isAccount
            initialData={sessionState.user}
            availableRoles={userManagementState.availableRoles}
            availableRoleRights={this.getRoleRightsBasedOnRole()}
            onClose={this.editAccountModalOnClose}
            onSave={this.editAccountModalOnClose}
          />
        )}
        {changePasswordModalVisible && (
          <ModalChangePassword
            showModal={changePasswordModalVisible}
            onClose={this.changePasswordModalOnClose}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...this.props}
          />
        )}
        {headChannelsConfigOpen && (
          <HeadChannelsConfig
            open={headChannelsConfigOpen}
            setOpen={(e) => {
              onSetHeadChannelsConfigOpen(e);
            }}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(SideMenuContainer));

SideMenuContainer.propTypes = {
  appState: PropTypes.any.isRequired,
  sessionState: PropTypes.any.isRequired,
  userManagementState: PropTypes.any.isRequired,
  licenseStatus: PropTypes.string.isRequired,
  protocolEditorAutosaveState: PropTypes.bool.isRequired,
  defaultViewSettings: PropTypes.any.isRequired,
  fastInstrumentType: PropTypes.string.isRequired,
  isHumidifierInstalled: PropTypes.bool.isRequired,
  isHumidifierConnected: PropTypes.bool.isRequired,

  checkAndUpdateIdleHumidityStatus: PropTypes.func.isRequired,
  onSetDrawerVisibility: PropTypes.func.isRequired,
  onSetHeadChannelsConfigOpen: PropTypes.func.isRequired,
  onChangeView: PropTypes.func.isRequired,
  onResetSelectedProtocolOrFolder: PropTypes.func.isRequired,
  onFastGetInstalledTrayAndOpenTrayCalibrationPage: PropTypes.func.isRequired,
  onShowModalConnectionFailed: PropTypes.func.isRequired,
  onShowIsBusyModal: PropTypes.func.isRequired,
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
  onShowSnackbar: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onRecoverRunningProtocol: PropTypes.func.isRequired,
  onGetInstrumentStatus: PropTypes.func.isRequired,
  onGetRunningProtocol: PropTypes.func.isRequired,
  onRecoveryAction: PropTypes.func.isRequired,
  onMoveToIdlePosition: PropTypes.func.isRequired,
  onGetFastInfo: PropTypes.func.isRequired,
  protocolManagementBusinessGoToProtocolEditor: PropTypes.func.isRequired,
  licenseBussinessGetLicenseData: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
  protocolManagementBusinessOnExistProtocolRunning: PropTypes.func.isRequired,
  modalStateBusinessActionShowTouchProbeExtendedModal: PropTypes.func.isRequired,
  userManagementBusinessIsOperator: PropTypes.func.isRequired,
  protocolEditorActionSetAutosaveEnableAutosave: PropTypes.func.isRequired,
  protocolEditorActionDisableAutosave: PropTypes.func.isRequired,
  commonModalBusinessShowConfirmationModal: PropTypes.func.isRequired,
  menuBusinessOpenSetupWizardPage: PropTypes.func.isRequired,
  errorHandlerBusinessfastCommonActuatorAPIErrorHandler: PropTypes.func.isRequired,
  instrumentBusinessVisionCompatibilityCheck: PropTypes.func.isRequired,
  saveStateAction: PropTypes.func.isRequired,
  userManagementBusinessSetExplorerViewSettings: PropTypes.func.isRequired,
  sideMenuBusinessOpenTipsPickupCalibrationMenu: PropTypes.func.isRequired,
  onCheckLoadCellError: PropTypes.func.isRequired,
  showModalType: PropTypes.func.isRequired,
  setErrorCodeNumber: PropTypes.func.isRequired,
  setInstrumentProcess: PropTypes.func.isRequired,
  isInstrumentOperational: PropTypes.bool.isRequired,
  isLabwareOperational: PropTypes.bool.isRequired,
};
